{
  "header": {
    "nameShowStaticText": false,
    "nameVariable": {
      "id": "7e0929b6-6870-451d-a6ce-f158df9066ac",
      "modelUri": "http://opcfoundation.org/UA/TTD/",
      "nodeId": "ns=1;i=6132",
      "displayName": "ProductInstanceUri",
      "variablePath": "Identification.ProductInstanceUri",
      "dataType": "String",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "modelShowStaticText": false,
    "modelVariable": {
      "id": "a9f2dbd8-cbcb-41ae-87d6-7c7e5807fe40",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "ns=1;i=6008",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Optional",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "machine.jpg"
    }
  },
  "timeline": {
    "variable": {
      "id": "1abd6a0d-0b8f-4396-84e6-42f94bd3574b",
      "modelUri": "http://opcfoundation.org/UA/TTD/",
      "nodeId": "ns=1;i=6136",
      "displayName": "CurrentState",
      "variablePath": "ItemState.CurrentState",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": true
    },
    "colorValues": {
      "Executing": "#04fb67",
      "NotExecuting": "#0073ff",
      "OutOfService": "#ff0000",
      "NotAvailable": "#930000"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "dcd09f11-6225-4d64-bb9d-dbb3e0f27c17",
                "modelUri": "http://opcfoundation.org/UA/TTD/",
                "nodeId": "ns=1;i=6133",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "ProductInstanceUri",
              "showAsLink": true,
              "valueVariable": {
                "id": "7e0929b6-6870-451d-a6ce-f158df9066ac",
                "modelUri": "http://opcfoundation.org/UA/TTD/",
                "nodeId": "ns=1;i=6132",
                "displayName": "ProductInstanceUri",
                "variablePath": "Identification.ProductInstanceUri",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "0234d964-6380-48f4-b3bf-cbdb12b9b856",
                "modelUri": "http://opcfoundation.org/UA/TTD/",
                "nodeId": "ns=1;i=6134",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Software Version",
              "showAsLink": false,
              "valueVariable": {
                "id": "73095409-b79e-4ce4-b12c-85fb4d89895b",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6011",
                "displayName": "SoftwareVersion",
                "variablePath": "Identification.SoftwareVersion",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Build Year",
              "showAsLink": false,
              "valueVariable": {
                "id": "ab0c35d3-787a-49a3-8827-cf3fb084b26a",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6004",
                "displayName": "YearOfConstruction",
                "variablePath": "Identification.YearOfConstruction",
                "dataType": "UInt16",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Device Class",
              "showAsLink": false,
              "valueVariable": {
                "id": "167abceb-8429-4882-9333-f3df453330de",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6012",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Location",
              "showAsLink": false,
              "valueVariable": {
                "id": "ac5f05f3-92b2-414d-9297-f62ca2d85777",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6029",
                "displayName": "Location",
                "variablePath": "Identification.Location",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "a9f2dbd8-cbcb-41ae-87d6-7c7e5807fe40",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6008",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Code",
              "showAsLink": false,
              "valueVariable": {
                "id": "f324c756-9993-492c-b5ae-5a8e9c003e66",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6009",
                "displayName": "ProductCode",
                "variablePath": "Identification.ProductCode",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Job Management",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Name",
              "showAsLink": false,
              "valueVariable": {
                "id": "87ae6221-8ae1-4d14-a21f-b9472c6679cd",
                "modelUri": "http://opcfoundation.org/UA/",
                "nodeId": "i=61",
                "displayName": "baseName",
                "variablePath": "baseName",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Job Id",
              "showAsLink": false,
              "valueVariable": {
                "id": "398b805c-9bc7-451e-a52e-47843a0b0520",
                "modelUri": "http://opcfoundation.org/UA/TTD/",
                "nodeId": "ns=1;i=6091",
                "displayName": "JobId",
                "variablePath": "JobId",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "Running"
                },
                {
                  "backgroundColor": "#2d00b3",
                  "textColor": "#ffffff",
                  "value": "Ended"
                },
                {
                  "backgroundColor": "#ffff80",
                  "textColor": "#000000",
                  "value": "Initializing"
                },
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#000000",
                  "value": "Aborted"
                }
              ],
              "label": "Current State",
              "valueVariable": {
                "id": "9ca78aff-2f52-4663-95d5-3efa96de3e27",
                "modelUri": "http://opcfoundation.org/UA/TTD/",
                "nodeId": "ns=1;i=6097",
                "displayName": "CurrentState",
                "variablePath": "State.CurrentState",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true
              }
            }
          ],
          "placeholderObject": "JobManagement.JobList.<OrderedObject>.[PLACEHOLDER]"
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Results",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Job Id",
              "showAsLink": false,
              "valueVariable": {
                "id": "9cc1de8c-d9f3-4a99-99da-f8d546afbf0e",
                "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
                "nodeId": "ns=0;i=31918",
                "displayName": "JobId",
                "variablePath": "ResultMetaData.JobOrder.JobId",
                "dataType": "TrimmedString",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Files",
              "showAsLink": false,
              "valueVariable": {
                "id": "9a25e82a-bcce-46d1-85b3-a4354584a24c",
                "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
                "nodeId": "ns=0;i=23751",
                "displayName": "ResultUri",
                "variablePath": "ResultMetaData.ResultUri",
                "dataType": "UriString",
                "valueRank": 1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Name",
              "showAsLink": false,
              "valueVariable": {
                "id": "1abd6a0d-0b8f-4396-84e6-42f94bd3574i",
                "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
                "nodeId": "ns=0;i=23751",
                "displayName": "Name",
                "variablePath": "ResultMetaData.JobOrder.RecipeId.Name",
                "dataType": "NodeId",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "SampleId",
              "showAsLink": false,
              "valueVariable": {
                "id": "1abd6a0d-0b8f-4396-84e6-42f94bd3574h",
                "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
                "nodeId": "ns=0;i=23751",
                "displayName": "SampleId",
                "variablePath": "ResultMetaData.SampleId",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 3,
              "isPlaceholder": false,
              "label": "SampleInfo",
              "rowPlaceholderObject": "ResultMetaData.JobOrder.AdditionalInfo.[PLACEHOLDER]",
              "columns": [
                {
                  "label": "Key",
                  "valueVariable": {
                    "id": "1abd6a0d-0b8f-4396-84e6-92f94bd3575f",
                    "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
                    "nodeId": "ns=0;i=23751",
                    "displayName": "Key",
                    "variablePath": "Key",
                    "dataType": "String",
                    "valueRank": -1,
                    "modellingRule": "Optional",
                    "hasProperties": false,
                    "hasUnit": false,
                    "hasRange": false
                  }
                },
                {
                  "label": "Value",
                  "valueVariable": {
                    "id": "1abd6a0d-0b8f-4396-84e6-42f98bd3576f",
                    "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
                    "nodeId": "ns=0;i=23751",
                    "displayName": "Value",
                    "variablePath": "Value",
                    "dataType": "String",
                    "valueRank": -1,
                    "modellingRule": "Optional",
                    "hasProperties": false,
                    "hasUnit": false,
                    "hasRange": false
                  }
                }
              ]
            },
            {
              "type": 3,
              "isPlaceholder": false,
              "label": "Statistic Result",
              "columns": [
                {
                  "label": "ResultKey",
                  "valueVariable": {
                    "id": "1abd6a0d-0b8f-4396-84e6-42f94bd3574f",
                    "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
                    "nodeId": "ns=0;i=23751",
                    "displayName": "ResultKey",
                    "variablePath": "ResultKey",
                    "dataType": "String",
                    "valueRank": -1,
                    "modellingRule": "Optional",
                    "hasProperties": false,
                    "hasUnit": false,
                    "hasRange": false
                  }
                },
                {
                  "label": "ItemCount",
                  "valueVariable": {
                    "id": "1abd6a0d-0b8f-4396-84e6-42f94bd3574e",
                    "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
                    "nodeId": "ns=0;i=23751",
                    "displayName": "ItemCount",
                    "variablePath": "ItemCount",
                    "dataType": "Int32",
                    "valueRank": -1,
                    "modellingRule": "Optional",
                    "hasProperties": false,
                    "hasUnit": false,
                    "hasRange": false
                  }
                },
                {
                  "label": "MeanValue",
                  "valueVariable": {
                    "id": "1abd6a0d-0b8f-4396-84e6-42f94bd3574d",
                    "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
                    "nodeId": "ns=0;i=23751",
                    "displayName": "MeanValue",
                    "variablePath": "MeanValue",
                    "dataType": "Double",
                    "valueRank": -1,
                    "modellingRule": "Optional",
                    "hasProperties": false,
                    "hasUnit": false,
                    "hasRange": false
                  }
                },
                {
                  "label": "StandardDeviation",
                  "valueVariable": {
                    "id": "1abd6a0d-0b8f-4396-84e6-42f94bd3574c",
                    "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
                    "nodeId": "ns=0;i=23751",
                    "displayName": "StandardDeviation",
                    "variablePath": "StandardDeviation",
                    "dataType": "Double",
                    "valueRank": -1,
                    "modellingRule": "Optional",
                    "hasProperties": false,
                    "hasUnit": false,
                    "hasRange": false
                  }
                },
                {
                  "label": "ConfidenceInterval95",
                  "valueVariable": {
                    "id": "1abd6a0d-0b8f-4396-84e6-42f94bd3574d",
                    "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
                    "nodeId": "ns=0;i=23751",
                    "displayName": "ConfidenceInterval95",
                    "variablePath": "ConfidenceInterval95",
                    "dataType": "Double",
                    "valueRank": -1,
                    "modellingRule": "Optional",
                    "hasProperties": false,
                    "hasUnit": false,
                    "hasRange": false
                  }
                }
              ],
              "rowPlaceholderObject": "ResultContent.[PLACEHOLDER]"
            }
          ],
          "placeholderObject": "ResultManagement.Results.<ResultVariable>.[PLACEHOLDER]",
          "titleVariable": {
            "id": "b2e2ffd0-1796-4d56-a949-96bbcce02c86",
            "modelUri": "http://opcfoundation.org/UA/Machinery/Result/",
            "nodeId": "ns=0;i=31918",
            "displayName": "ResultId",
            "variablePath": "ResultMetaData.ResultId",
            "dataType": "TrimmedString",
            "valueRank": -1,
            "modellingRule": "Mandatory",
            "hasProperties": false
          }
        }
      ]
    }
  ]
}
